import React from 'react';
import { Text } from '@adc/parallax-component-library';
import { Link } from './Link';
import { List, ListItem } from './List';
export function getDefaultTransComponents(onPressLink, customNodes, fontToken) {
    return {
        p: React.createElement(Text, { tag: "p", display: "block", marginBlockStart: "$4", marginBlockEnd: "$4", type: fontToken }),
        strong: React.createElement(Text, { tag: "strong", type: "$bodyBase.strong" }),
        h1: React.createElement(Text, { tag: "h1", type: "$h1.strong" }),
        h2: React.createElement(Text, { tag: "h2", type: "$h2.strong" }),
        h3: React.createElement(Text, { tag: "h3", type: "$h3.strong" }),
        h4: React.createElement(Text, { tag: "h4", type: "$h4.strong" }),
        a: React.createElement(Link, { onPressLink: onPressLink, fontToken: fontToken }),
        li: React.createElement(ListItem, { fontToken: fontToken }),
        ul: React.createElement(List, { listType: "ul" }),
        ol: React.createElement(List, { listType: "ol" }),
        br: React.createElement("br", null),
        ...customNodes,
    };
}
